var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6663,
    cy: 15.9999,
    rx: 7.33333,
    ry: 6.66667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 2.66675C8.65366 2.66675 2.66699 8.65341 2.66699 16.0001C2.66699 23.3467 8.65366 29.3334 16.0003 29.3334C23.347 29.3334 29.3337 23.3467 29.3337 16.0001C29.3337 8.65341 23.347 2.66675 16.0003 2.66675ZM22.2803 14.28L15.6136 20.9467C15.347 21.2 15.0137 21.3334 14.667 21.3334C14.3203 21.3334 13.987 21.2 13.7203 20.9467L9.72034 16.9467C9.20034 16.4267 9.20034 15.5735 9.72034 15.0535C10.2403 14.5335 11.0936 14.5335 11.6136 15.0535L14.667 18.1202L20.387 12.3868C20.907 11.8668 21.7603 11.8668 22.2803 12.3868C22.8003 12.9068 22.8003 13.76 22.2803 14.28Z",
    fill: "#6C01A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.e346e8a5.svg";
export { ForwardRef as ReactComponent };